import { useDisclosure } from '@chakra-ui/react';
import * as React from 'react';
import { useCounter, usePrevious } from 'react-use';

export const useUniqueDisclosure = (): IUseUniqueDisclosureReturn => {
  const [modalKey, { inc: newModalKey }] = useCounter(0);
  const { isOpen, onOpen, onClose, onToggle } = useDisclosure();
  const lastIsOpen = usePrevious(isOpen);

  React.useEffect(() => {
    if (isOpen && !lastIsOpen) {
      newModalKey();
    }
  }, [isOpen, lastIsOpen, newModalKey]);

  return {
    modalKey,
    isOpen,
    onOpen,
    onClose,
    onToggle,
  };
};

export interface IUseUniqueDisclosureReturn {
  isOpen: boolean;
  modalKey: number;
  onClose: () => void;
  onOpen: () => void;
  onToggle: () => void;
}
